import { Getters } from 'vuex-smart-module';
import PartnerProductsState from './state';

export default class PartnerProductsGetters extends Getters<PartnerProductsState> {}
